export class ApiBase {
  public handleResponse: (response: Response) => Promise<any> = response => {
    if (response.status === 201 || response.status === 204) {
      return Promise.resolve();
    }
    if (response.status >= 200 && response.status < 300) {
      return response.text().then(text => (text ? JSON.parse(text) : {}));
    }
    throw response;
  };

  public post: (url: string, dto: any) => Promise<any> = (url, dto) => {
    return fetch(url, {
      body: JSON.stringify(dto),
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer"
    }).then(this.handleResponse);
  };

  public get: (url: string, cache?: RequestCache) => Promise<any> = (
    url,
    cache
  ) => {
    return fetch(url, {
      //cache: cache || "default",
      //credentials: "same-origin",
      //headers: {
      //  "Content-Type": "application/json"
      //},
      method: "GET",
      //mode: "cors"
      //redirect: "follow",
      //referrer: "no-referrer"
    }).then(this.handleResponse);
  };
}
